import { render, staticRenderFns } from "./PortraitRankingCell.vue?vue&type=template&id=da1270d0"
import script from "./PortraitRankingCell.vue?vue&type=script&lang=js"
export * from "./PortraitRankingCell.vue?vue&type=script&lang=js"
import style0 from "@/assets/scss/import/portrait.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./PortraitRankingCell.vue?vue&type=style&index=1&id=da1270d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports